function normalizeParents(parents) {
  return Array.isArray(parents) ? parents : [];
}

function getBreadcrumbParents(meta, currentRoute) {
  const breadcrumbFrom = currentRoute && currentRoute.query && currentRoute.query.breadcrumbFrom;
  const parentMap = meta && meta.breadcrumbParentMap;

  if (breadcrumbFrom && parentMap && parentMap[breadcrumbFrom]) {
    return normalizeParents(parentMap[breadcrumbFrom]);
  }

  return normalizeParents(meta && meta.breadcrumbParents);
}

function appendBreadcrumb(breadcrumbs, item) {
  if (!item || !item.title) return;

  const last = breadcrumbs[breadcrumbs.length - 1];
  if (last && last.title === item.title && last.path === item.path) return;

  breadcrumbs.push({
    title: item.title,
    path: item.path
  });
}

function buildBreadcrumb(matchedRoutes, currentRoute) {
  const breadcrumbs = [{ title: '首页', path: '/home/index' }];

  normalizeParents(matchedRoutes).forEach(route => {
    const meta = route && route.meta;
    if (!meta || !meta.title || meta.title === '首页') return;

    getBreadcrumbParents(meta, currentRoute).forEach(parent => {
      appendBreadcrumb(breadcrumbs, parent);
    });

    appendBreadcrumb(breadcrumbs, {
      title: meta.title,
      path: route.path
    });
  });

  return breadcrumbs;
}

module.exports = {
  buildBreadcrumb
};
